import moneyHelper from '../../helpers/money';
import { createModule, toggleModule, setnumberOfItems } from '../../actions';
import { PAY_PER_USE } from '../../helpers/consts';
import { GtmDataLayer } from '../../data/gtmDataLayer';
import Amount from "../../helpers/amount";

const cssClasses = {
    module: 'module',
    moduleActive: 'module--active',
    moduleInput: 'module__input',
    moduleLabel: 'module__label',
    modulePrice: 'module__price',
};

export class ModuleInput {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.moduleType = options.moduleType;
        this.id = options.id;
        this.name = options.name;
        this.amount = options.amount;
        this.bundlePrice = options.bundlePrice;
        this.bundleQuantity = options.bundleQuantity;
        this.numberOfItems = options.numberOfItems;
        this.bundle = options.bundleQuantity && options.bundlePrice;
        this.builtInPackage = options.builtInPackage;
        this.active = (this.bundle && this.builtInPackage) ? true : options.active;
        this.modal = options.modal;
        this.internalId = options.internalId;
        this.dependencyOfUser = this.state.users.find(user => user.dependency === this.internalId);
        this.$el = this.createModuleInputElement(
            options.name,
            options.label,
            options.labelType,
            options.amount,
            options.unit,
            options.description,
            options.readMoreLink,
            options.bundlePrice,
            options.nonBundlePrice,
            options.bundleQuantity,
            options.hideNonBundlePrice,
            options.builtInPackage,
            options.billingUnit,
            options.billingUnitPlural,
            options.active
        );

        if (!this.state.modules) {
            // Pass bundleQuantity as initial value of numberOfItems.
            this.store.dispatch(createModule(
                options.internal_id,
                options.id,
                options.moduleType,
                options.name,
                options.label,
                options.labelType,
                options.amount,
                options.unit,
                options.description,
                options.readMoreLink,
                options.bundlePrice,
                options.nonBundlePrice,
                options.bundleQuantity,
                options.numberOfItems,
                options.hideNonBundlePrice,
                options.builtInPackage,
                options.billingUnit,
                options.billingUnitPlural,
                options.active,
            ));
        }
        this.store.subscribe(this.update.bind(this));

        // Auto-enable in case of bundle.
        if (this.bundle) {
            this.store.dispatch(toggleModule(this.moduleType, this.active));
        }

        this.update();
    }

    createModuleInputElement(
        name = '',
        label = '',
        labelType = 0,
        amount = 0,
        unit = '',
        description = '',
        readMoreLink = '',
        bundlePrice = 0,
        nonBundlePrice = 0,
        bundleQuantity = 0,
        hideNonBundlePrice = 0,
        builtInPackage = 0,
        billingUnit = '',
        billingUnitPlural = '',
    ) {
        const $moduleElem = document.createElement('div');
        const labelTypes = [
            'module__label label--green',
            'module__label label--blue',
        ];
        let labelElem = '';
        let descriptionElem = '';
        let bundleElem = '';

        if (label !== '') {
            labelElem  = `<span class="${labelTypes[labelType - 1]}"><i class="fa fa-check"></i>${label}</span>`;
        }
        if (description !== '') {
            descriptionElem = `<div class="row">
                <div class="col-12">
                    <div class='module__description'>${description} ${readMoreLink !== '' ? `<a href="${readMoreLink}" data-modal='${readMoreLink}' >${__('Read more')}</a>` : ''}</div>
                </div>
            </div>`;
        }

        let toggleArea = `<div class="col-12 col--toggle-button"><span class='module__price h5'>${Number(amount) !== 0 ? moneyHelper.formatPrice(amount) : PAY_PER_USE } ${Number(amount) !== 0 ? unit : ''}</span></div>`;

        if (this.bundle) {
            let outOfBundle = '';
            if (parseFloat(nonBundlePrice) && Number(hideNonBundlePrice) !== 1) {
                outOfBundle = `<div class='bundle__description nonbundle__price'>${__('Out of bundle unit price')}: ${moneyHelper.formatPrice(nonBundlePrice)}${billingUnit ? ` per ${billingUnit}` : ''}</div>`
            }
            bundleElem = `<div class="row">
                <div class="col-12 col-bundle-description">
                    <div class='bundle__description bundle__quantity'>${__('Minimum bundle quantity')}: ${bundleQuantity}${bundleQuantity > 1 ? ` ${billingUnitPlural}` : ` ${billingUnit}`}</div>
                    <div class='bundle__description bundle__price'>${__('Bundle unit price')}: ${moneyHelper.formatPrice(bundlePrice)}${billingUnit ? ` per ${billingUnit}` : ''}</div>
                    ${outOfBundle}
                </div>
            </div>`;

            toggleArea = `<div class="col-12 col--toggle-button col--bundle-module"><div class="number-of-items__input"></div></div>`
        }

        const moduleElemHTML = `
            <div class="row row--head">
                <div class="col-12"><h5 class='name'>${name}</h5>${labelElem}</div>
            </div>
            ${bundleElem}
            ${descriptionElem}
            <div class="row row--foot">
                ${toggleArea}
            </div>
        `;

        if (this.bundle) {
            this.$minusButton = this.createMinusButton();
            this.$amountInput = this.createAmountInput();
            this.$plusButton = this.createPlusButton();
            if (!builtInPackage) {
                this.$toggleButton = this.createToggleButton();
            }
        } else {
            this.$toggleButton = this.createToggleButton();
        }


        $moduleElem.classList.add('module');
        $moduleElem.innerHTML = moduleElemHTML;

        const modalLink = $moduleElem.querySelector('[data-modal]');

        if (modalLink) {
            modalLink.addEventListener('click', (event) => {
                event.preventDefault();
                if (modalLink.getAttribute('data-modal').includes('.pdf')) {
                    this.modal.setContent(`<object width="100%" data="${modalLink.getAttribute('data-modal')}"></object>`);
                } else {
                    this.modal.setContent(`<iframe src="${modalLink.getAttribute('data-modal')}" frameborder="0" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>`);
                }
                this.modal.open();
            });
        }

        if (this.bundle) {
            if (!builtInPackage) {
                $moduleElem.querySelector('.col--bundle-module').appendChild(this.$toggleButton);
            }
            $moduleElem.querySelector('.number-of-items__input').appendChild(this.$minusButton);
            $moduleElem.querySelector('.number-of-items__input').appendChild(this.$amountInput);
            $moduleElem.querySelector('.number-of-items__input').appendChild(this.$plusButton);
        } else if (this.id !== 'placeholder') {
            $moduleElem.querySelector('.col--toggle-button').appendChild(this.$toggleButton);
        }


        const gtmProductData = {
            name: this.name,
            id: this.id,
            price: this.bundlePrice,
            quantity: this.numberOfItems,
            productCode: this.state.product.productCode,
            packageCode: this.state.product.packageCode,
        };
        const gtmStepData = {
            name: this.state.steps.find(step => step.current === true).name,
            id: this.state.steps.find(step => step.current === true).id,
        };

        if (this.active) {
            GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
        }

        return $moduleElem;
    }

    createPlusButton() {
        const $buttonElem = document.createElement('button');
        const $buttonInnerElem = document.createElement('span');
        const $buttonElemText = document.createTextNode('+');
        const $numberOfItemsTooltipElem = document.createElement('span');
        $numberOfItemsTooltipElem.classList.add(cssClasses.tooltipContent);

        $buttonElem.type = 'button';
        $buttonElem.classList.add('btn');
        $buttonElem.classList.add('btn--plus', 'btn-sm');
        $buttonInnerElem.classList.add('btn__inner');
        $buttonInnerElem.appendChild($buttonElemText);
        $buttonElem.appendChild($buttonInnerElem);

        $buttonElem.addEventListener(
            'click',
            () => {
                this.numberOfItems = parseInt(this.numberOfItems, 10) + 1;
                this.store.dispatch(
                    setnumberOfItems(this.moduleType, this.numberOfItems)
                );

                const gtmProductData = {
                    name: this.name,
                    id: this.id,
                    price: this.bundlePrice,
                    quantity: this.numberOfItems,
                    productCode: this.state.product.productCode,
                    packageCode: this.state.product.packageCode,
                };
                const gtmStepData = {
                    name: this.state.steps.find(step => step.current === true).name,
                    id: this.state.steps.find(step => step.current === true).id,
                };

                GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
            },
            true
        );

        return $buttonElem;
    }

    createMinusButton() {
        const $buttonElem = document.createElement('button');
        const $buttonInnerElem = document.createElement('span');
        const $buttonElemText = document.createTextNode('-');

        $buttonElem.type = 'button';
        $buttonElem.classList.add('btn');
        $buttonElem.classList.add('btn--minus', 'btn-sm');
        $buttonInnerElem.classList.add('btn__inner');
        $buttonInnerElem.appendChild($buttonElemText);
        $buttonElem.appendChild($buttonInnerElem);
        $buttonElem.disabled = (this.numberOfItems === this.bundleQuantity);

        $buttonElem.addEventListener(
            'click',
            () => {
                if (this.numberOfItems > this.bundleQuantity) {
                    this.numberOfItems = parseInt(this.numberOfItems, 10) - 1;
                    this.store.dispatch(
                        setnumberOfItems(this.moduleType, this.numberOfItems)
                    );
                    const gtmProductData = {
                        name: this.name,
                        id: this.id,
                        price: this.bundlePrice,
                        quantity: this.numberOfItems,
                        productCode: this.state.product.productCode,
                        packageCode: this.state.product.packageCode,
                    };
                    const gtmStepData = {
                        name: this.state.steps.find(step => step.current === true).name,
                        id: this.state.steps.find(step => step.current === true).id,
                    };

                    GtmDataLayer.removeFromCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
                }
            },
            true
        );

        return $buttonElem;
    }

    createAmountInput() {
        const $inputElem = document.createElement('input');

        $inputElem.type = 'number';
        $inputElem.id = `number-of-items-${this.moduleType.toLowerCase()}`;
        $inputElem.min = this.bundleQuantity;
        $inputElem.value = this.bundleQuantity;
        $inputElem.classList.add('input--number', 'form-control', 'text-center');

        $inputElem.addEventListener(
            'change',
            () => {
                const oldNumberOfItems = this.numberOfItems;
                const newnumberOfItems = parseInt($inputElem.value, 10);
                if (
                    Number.isInteger(newnumberOfItems) &&
                    newnumberOfItems > this.bundleQuantity
                ) {
                    this.numberOfItems = newnumberOfItems;
                } else {
                    this.numberOfItems = this.bundleQuantity;
                }

                this.store.dispatch(
                    setnumberOfItems(this.moduleType, this.numberOfItems)
                );

                const gtmProductData = {
                    name: this.name,
                    id: this.id,
                    price: this.bundlePrice,
                    quantity: this.numberOfItems,
                    productCode: this.state.product.productCode,
                    packageCode: this.state.product.packageCode,
                };
                const gtmStepData = {
                    name: this.state.steps.find(step => step.current === true).name,
                    id: this.state.steps.find(step => step.current === true).id,
                };

                if (oldNumberOfItems < this.numberOfItems) {
                    GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
                } else {
                    GtmDataLayer.removeFromCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
                }

            },
            true
        );

        return $inputElem;
    }

    toggleButtons() {
        this.$minusButton.disabled = (this.numberOfItems === this.bundleQuantity);
    }

    updateNumberOfItemsInput(numberOfItems) {
        this.numberOfItems = numberOfItems;
        this.$amountInput.value = numberOfItems;
    }

    createToggleButton() {
        const $buttonElem = document.createElement('button');
        const $iconElem = document.createElement('i');
        const $buttonInnerElem = document.createElement('span');

        $iconElem.classList.add('fa');
        $iconElem.classList.toggle('fa-plus', !this.active);
        $iconElem.classList.toggle('fa-check', this.active);
        $buttonInnerElem.textContent = this.active ? __('Added') : __('Add');
        $buttonElem.type = 'button';
        $buttonElem.classList.add('button', 'button--secondary', 'btn--toggle');
        $buttonInnerElem.classList.add('button__text');
        $buttonElem.appendChild($iconElem);
        $buttonElem.appendChild($buttonInnerElem);

        $buttonElem.addEventListener('click', () => {
            this.active = !this.active;
            document.body.classList.add('animate');
            this.store.dispatch(toggleModule(this.moduleType, this.active));
            if (this.dependencyOfUser) {
                this.store.dispatch(
                    setnumberOfItems(this.dependencyOfUser.userType, this.dependencyOfUser.minnumberOfItems)
                );
            }
            $iconElem.classList.toggle('fa-plus', !this.active);
            $iconElem.classList.toggle('fa-check', this.active);
            $buttonInnerElem.textContent = this.active ? __('Added') : __('Add');

            const gtmProductData = {
                name: this.name,
                id: this.id,
                price: this.bundlePrice,
                quantity: this.numberOfItems,
                productCode: this.state.product.productCode,
                packageCode: this.state.product.packageCode,
            };
            const gtmStepData = {
                name: this.state.steps.find(step => step.current === true).name,
                id: this.state.steps.find(step => step.current === true).id,
            };

            if (this.active) {
                GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
            } else {
                GtmDataLayer.removeFromCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
            }

        }, true);

        return $buttonElem;
    }

    updateModuleInput(module) {
        this.$el.classList.toggle(cssClasses.moduleActive, module.active);
    }

    update() {
        this.state = this.store.getState();

        if (this.bundle) {
            const updatedBundle = this.state.modules.find(
                module => module.moduleType === this.moduleType
            );
            this.toggleButtons();
            this.updateNumberOfItemsInput(updatedBundle.numberOfItems);
            this.updateModuleInput(updatedBundle);
        } else {
            const updatedModule = this.state.modules.find(module => module.moduleType === this.moduleType);
            this.updateModuleInput(updatedModule);
        }
    }

    render() {
        return this.$el;
    }
}

export default ModuleInput;
